<template>
  <div class="System">
    <h1>系统设置 </h1>
    <p>大屏页面刷新时间: {{ refreshTimeDis }}秒</p>
   	<input v-model="refreshTime" placeholder="edit me" />

     <p>
    <button v-on:click="click()">更新</button>
  </p>
  </div>
</template>


<script>
export default {
  name:'about',
  data() {
    return {
      refreshTime: 30,
      refreshTimeDis: 30
    }
  },
  mounted(){
   
    this.$data.refreshTime =this.$cookies.get('refreshTime')

  },
  methods:{
    click(){

      this.$cookies.set('refreshTime', this.$data.refreshTime )
      this.refreshTimeDis = this.refreshTime;
    }
  }
}
</script>

<style lang="less">
.System {
  margin: auto;


}

.dialogEdit {
  box-sizing: border-box;
  width: 40%;
  background-color: rgba(163, 178, 241, 0.7);
  border-radius: 3px;

}
</style>